import { observable } from 'mobx';

class QuizStore {
  @observable configuration = {
    certificate: null,
    certificateActive: false,
    certificateReleasePercentage: 0,
    maxQuestionToRandom: 5,
    minimumScorePercent: 0,
    minimumScoreRequired: false,
    randomAnswerOrder: false,
    randomQuestion: false,
    retry: false,
    retryInterval: null,
    showAnswersAfterResult: false
  };
  @observable page = {
    hasDuration: false,
    liberationDate: null,
    liberationDays: null,
    liberationType: null,
    name: '',
    content: '',
    published: false,
    pageLanguage: {
      language: '',
      signLanguage: false
    }
  };

  @observable profiles = [];
  @observable questions = [
    {
      answers: [
        {
          correct: true,
          id: 'new_a',
          order: 1,
          text: ''
        }
      ],
      id: 'new_q',
      mandatory: false,
      order: 1,
      text: ''
    }
  ];
  @observable type = 'EXERCISE';

  @observable profileImages = [];
  snapshot = {};
}

export default new QuizStore();
